import { AxiosProgressEvent, AxiosResponse } from 'axios';
import { ImportRecord, UpdateImportRequest } from '../types/Import';
import httpClient from './httpClient';

const IMPORT_BASE_ROUTE = '/v1/import';

export async function uploadImportFile(
  workspaceId: number,
  file: File,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
): Promise<AxiosResponse<ImportRecord>> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('workspaceId', String(workspaceId));

  return httpClient({
    method: 'POST',
    url: `${IMPORT_BASE_ROUTE}/upload`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
}

export async function getImports(workspaceId: number): Promise<AxiosResponse<ImportRecord[]>> {
  return httpClient({
    method: 'GET',
    url: `${IMPORT_BASE_ROUTE}/?workspaceId=${workspaceId}`,
  });
}

export async function getImport(importId: number): Promise<AxiosResponse<ImportRecord>> {
  return httpClient({
    method: 'GET',
    url: `${IMPORT_BASE_ROUTE}/${importId}`,
  });
}

export async function updateImport(
  importId: number,
  data: UpdateImportRequest
): Promise<AxiosResponse<ImportRecord>> {
  return httpClient({
    method: 'PATCH',
    url: `${IMPORT_BASE_ROUTE}/${importId}`,
    data,
  });
}

export async function executeImport(importId: number): Promise<AxiosResponse<void>> {
  return httpClient({
    method: 'POST',
    url: `${IMPORT_BASE_ROUTE}/${importId}/execute`,
  });
}

export async function deleteImport(importId: number): Promise<AxiosResponse<void>> {
  return httpClient({
    method: 'DELETE',
    url: `${IMPORT_BASE_ROUTE}/${importId}`,
  });
}
